
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBarrasLaterales } from './controlador';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorBarrasLaterales;

        @Prop()
        public Pedido: Pedido;

        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Pedido.Cliente; }

    }
